import { applyMiddleware, combineReducers, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import createSagaMiddleware from "@redux-saga/core";
import { authReducer } from "./reducers/authReducer";
import { rootWatcher } from "../sagas";
import { householdsReducer } from "./reducers/householdsReducer";
import { personsReducer } from "./reducers/personReducer";
import { addressesReducer } from "./reducers/addressesReducer";
import { categoriesReducer } from "./reducers/categoriesReducer";
import { visitsReducer } from "./reducers/visitsReducers";
import { routesReducer } from "./reducers/routesReducer";
import { generalReducer } from "./reducers/generalReducer";
import { teamReducer } from "./reducers/teamReducer";
import { notificationsReducer } from "./reducers/notificationsReducer";
import { billingReducer } from "./reducers/billingReducer";
import { adminReducer } from "./reducers/adminReducer";
import { integrationsReducer } from "./reducers/integrationsReducer";
import { routeDivisionReducer } from "./reducers/routeDivisionReducer";
import { dashboardReducer } from "./reducers/dashboardReducer";
import { adminDashboardReducer } from "./reducers/adminDashboardReducer";
import { projectsReducer } from "./reducers/projectsReducer";
import { offlineReducer } from "./reducers/offlineReducer";
import { persistReducer, persistStore } from "redux-persist";
import { persistConfig, initStorageGuard } from "./persistConfig";

const rootReducer = combineReducers({
  authStore: authReducer,
  householdsStore: householdsReducer,
  personsStore: personsReducer,
  addressesStore: addressesReducer,
  categoriesStore: categoriesReducer,
  visitsStore: visitsReducer,
  routesStore: routesReducer,
  generalStore: generalReducer,
  teamStore: teamReducer,
  notificationsStore: notificationsReducer,
  billingStore: billingReducer,
  adminStore: adminReducer,
  adminDashboardStore: adminDashboardReducer,
  integrationsStore: integrationsReducer,
  routeDivisionStore: routeDivisionReducer,
  dashboardStore: dashboardReducer,
  projectsStore: projectsReducer,
  offlineStore: offlineReducer,
});

const sagaMiddlewere = createSagaMiddleware();

// Persisted so a volunteer who reloads (or whose phone kills the tab) in a dead
// zone still sees the route, contacts and lookups that were already loaded.
const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = createStore(
  persistedReducer,
  composeWithDevTools(applyMiddleware(sagaMiddlewere))
);

export const persistor = persistStore(store);

// Ask the browser how much room we actually have before the first write happens.
// If it loses the race, the first persist simply runs unguarded.
void initStorageGuard();

sagaMiddlewere.run(rootWatcher);

export type StateType = ReturnType<typeof rootReducer>;

type PropertiesTypes<T> = T extends { [key: string]: infer U } ? U : never;

export type InferActionsTypes<
  T extends { [key: string]: (...args: any[]) => any }
> = ReturnType<PropertiesTypes<T>>;
